<template>  
    <section :class='isShowStatus?"":"no-p"'>
        <!-- 支付弹框 -->
        <pay-modal :payPrice="detailList.order_total_price" v-if="isPayModal"  :showClose="true"
            @close-modal="onCloseModalClick" @payClick='payClick' @goToCharge="goToCharge">
        </pay-modal>
        
        <!-- 是否取消订单 -->
        <confirm-modal v-if="isCancel" :noWidth="true" :firmTitle="firmTitle_1" :firmLeft="firmLeft_1" :firmRight="firmLeft"
            @leftClick="operateOrder(1)" @rightClick="onCloseModalClick">
        </confirm-modal>
        
        <!-- 是否完成订单 -->
        <confirm-modal v-if="isSubmit" :firmTitle="firmTitle" :firmLeft="firmLeft" :firmRight="firmRight"
            @leftClick="onCloseModalClick" @rightClick="operateOrder(2)">
        </confirm-modal>
        
        <!-- 钱包余额不足弹框 -->
        <confirm-modal v-if="noEnough" :isEnough="true" :firmTitle="firmTitle_2" :firmLeft="firmLeft" :firmRight="firmLeft_2"
            @leftClick="onCloseModalClick" @rightClick="goToCharge">
        </confirm-modal>
        
		<!-- 新撤单,退款弹框-->
		<common-tips v-if="isShowTips" :tipObj="tipObj" @showAgreeMent="isAgreeMent=true" @submitFun="submitFun" @close-modal="onCloseModalClick"></common-tips>
		
		<!-- 下单协议弹框 -->
		<show-agree-ment v-if="isAgreeMent" @close-modal="onCloseModalAgree"></show-agree-ment>
		
		<!-- 驳回订单 -->
		<common-reject v-if="isReject" @clickReject="clickReject" @close-modal="onCloseModalClick"></common-reject>
		
        <!-- 驳回成功弹框 -->
        <toast-modal :isToast="isToast" :ToastText="ToastText"></toast-modal>

		<!-- 扫码支付 -->
		<qr-code-url v-if="qrcodeUrl" :qrcodeUrl="qrcodeUrl" tips="支付" :chargeMoney="detailList.order_total_price" @deletePay="onCloseModalClick"></qr-code-url>
		
		<!-- 添加进度 -->
		<supply-and-follow v-if="isSupplyFollow" :objSupplyFollow="objSupplyFollow" @submitSupplyAdd="submitSupplyAdd" @close-modal="onCloseModalClick"></supply-and-follow>
		
		<!-- 订单进度 -->
		<progress-bar :detailList="detailList" role="user"></progress-bar>
		
		<!-- 服务项目信息 -->
		<service-items :detailList="detailList" role="user"></service-items>
		<contact-info :detailList="detailList"></contact-info>
		<after-sale :detailList="detailList"></after-sale>
		<div class="order-detail" v-if="detailList.order_supplement">
		    <div class="link-wrap">
				<img src="@/assets/images/order-manage/ic_home_line_6.png" alt="" class="pt-img">
		        <span class="link">补充信息</span>
		    </div>
			<p class="supply-content">{{detailList.order_supplement}}</p>
		    <div class="img-list">
		        <img v-for="(item,index) in detailList.order_supplement_img" :key="index" :src="item" alt="" @click="handleImgsClick(detailList.order_supplement_img,index)" class="img-size" />
		    </div>
		</div>
		<agree-ment></agree-ment>
		
		<!-- 处理中（未分配业务员) 已取消 无操作按钮 -->
		<div class="operat" v-if="isShowStatus">
			<!-- 1待支付 -->
			<div v-if="detailList.order_status==1" class="only-one">
				<span class="notes" @click="supply" v-if="!detailList.order_supplement">补充</span>
				<span class="notes" @click="cancel">取消订单</span>
				<span class="complete" @click="payMent">付款</span>
				<span class="complete" @click="follow">进度</span>
			</div>
			
			<!-- 3处理中（已分配业务员) -->
			<div v-if="(detailList.order_status==3 || detailList.order_status==13) && !!detailList.salesman_uuid" class="only-one">
				<span class="notes" 	@click="supply"  v-if="!detailList.order_supplement">补充</span>
				<span class="notes"     @click="refund"  v-if="detailList.isOverFive">退款</span>
				<span class="notes" 	@click="rescind" v-else>撤单</span> 
				<span class="complete"  @click="follow">进度</span>
			</div>
			
			<!-- 4待确认 -->
			<div v-if="detailList.order_status==4" class="only-one">
				<span class="notes" @click="supply" v-if="!detailList.order_supplement">补充</span>
				<span class="notes"  @click="reject">驳回</span>
				<span class="notes" @click="follow">进度</span>
				<span class="complete"  @click="submit">完成</span>
			</div>
			
			<!-- 5已完成 -->
			<div v-if="detailList.order_status==5" class="only-one">
				<span class="notes" @click="supply" v-if="!detailList.order_supplement">补充</span>
				<span class="notes" v-if="detailList.is_comment==1" @click="comment">吐槽</span>
                <span class="complete"  v-if="detailList.is_comment==2">已吐槽</span>
				<span class="complete" @click="follow">进度</span>
			</div>
			
			<!-- 8已驳回-->
			<div v-if="detailList.order_status==8" class="only-one">
				<span class="notes" @click="supply" v-if="!detailList.order_supplement">补充</span>
				<span class="complete"  @click="submit">完成</span>
				<span class="complete only-one" @click="follow">进度</span>
			</div>
			
			<!-- 9已退款 10退款中 11未解决 -->
			<div  v-if="detailList.order_status==9 || detailList.order_status==10 || detailList.order_status==11" class="only-one">
				<span class="notes" @click="supply" v-if="!detailList.order_supplement">补充</span>
				<span :class='detailList.order_status!=10?"complete":"notes"' @click="refund">退款</span>
				<span class="complete only-one" @click="follow">进度</span>
			</div> 
		</div>
    </section>
</template>

<script>
	import ProgressBar from '@/components/ProgressBar'
	import CommonTips from '@/components/CommonTips'
	import ContactInfo from '@/components/ContactInfo';
	import ShowAgreeMent from '@/components/ShowAgreeMent'
    import ConfirmModal from '@/components/ConfirmModal'
    import PayModal from '@/components/PayModal'
    import ToastModal from '@/components/ToastModal'
	import AfterSale from '@/components/AfterSale'
	import QrCodeUrl from '@/components/QrCodeUrl'
	import ServiceItems from '@/components/ServiceItems'
	import CommonReject from '@/components/CommonReject'
	import SupplyAndFollow from '@/components/SupplyAndFollow'
	import AgreeMent from '@/components/AgreeMent'
	import {getOrderDetail,operateOrder,getOrderPay,addSupplement} from '@/api/order'
    import utils from '@/assets/jslibs/utils'
  import wx from "weixin-js-sdk";
    export default {
        name: 'service-order',
        data:function(){
            return {
				isAgreeMent:false,
				isShowTips:false,			//是否显示撤单弹框
				tipObj:{					//撤单和退款提示
					title:"",
					content:"",
					num:null
				},
				addImages:[],
				isSupplyFollow:false,				//补充资料弹窗
				objSupplyFollow:{title:"订单信息补充",inputVal:"订单资料不全可以补充到这里哈，麻烦您~~"},
				imgUrl:this.$store.state.imgUrl || sessionStorage.getItem("imgUrl"),
                isPayModal:false,     //支付弹框
                isCancel:false,
                isSubmit:false,
                firmTitle_1:"是否取消当前订单",
                firmTitle:"是否确认完成当前订单",
                firmTitle_2:"钱包余额不足 该充值啦",
                firmLeft:"返回",
                firmRight:"确定",
                firmLeft_1:"确认",
                firmLeft_2:"充值",
				noEnough:false,         //余额不足弹框
				order_uuid:this.$route.query.order_uuid,
				detailList:{
					server_info:{}
				},
				isReject:false,
                ToastText:"",     //驳回，催单，取消成功提示语
                isToast:false,

				pay_type:"",        //支付方式（包括追加订单支付）
				qrcodeUrl : '',
				timer:null,
				isMobile : utils.isMobile(),
                payStyle:1,				//选择支付的方式
				clickPay:true,
                showTips:true,
				isShowStatus:false
            }
        },
        components: {
			ContactInfo,
			ShowAgreeMent,
            ToastModal,
            PayModal,
            ConfirmModal,
			AfterSale,
			QrCodeUrl,
			ServiceItems,
			CommonTips,
			CommonReject,
			SupplyAndFollow,
			AgreeMent,
			ProgressBar
        },
		
		beforeCreate(){
			sessionStorage.setItem("roleType","customer")
		},
      
        created() {
            this.getOrderDetail();
			clearTimeout(this.timer);
			clearTimeout(this.addTimer);
        },
        
        mounted(){
            document.title = "订单详情";
            window.addEventListener('touchmove', (event)=>{ 
                if(this.isSubmit || this.isCancel || this.isReject || this.isSupplyFollow ||
                this.isPayModal ||this.noEnough || this.isShowTips || this.isAgreeMent){
                    event.preventDefault(); 
                }
            }) 
			
			window.addEventListener('pageshow',()=>{
			    if(sessionStorage.getItem("havePay") && sessionStorage.getItem("payId")) {
			        this.order_uuid = sessionStorage.getItem("payId");      //取成功支付之后的订单号
			        this.getPayStatus(); 
                    sessionStorage.removeItem("havePay");               //开始执行轮训，就清除标示
                    sessionStorage.removeItem("payId");
			    }
			})
        },
        
        methods: {
			//获取订单详情
			async getOrderDetail(){
				const { data, status } = await getOrderDetail(this.order_uuid);
				if (status !== 200) return 
				this.detailList = data;
				this.detailList.after_sale_name = utils.typeToName(this.detailList.after_sale_type);
				this.detailList.statusName = utils.statusToName(this.detailList.order_status);
				this.detailList.question_url = this.detailList.question_url.split(",");
				if(this.detailList.statusName == "已撤单" || this.detailList.statusName == "待处理"|| this.detailList.statusName == "已撤回"){
					this.detailList.statusName = "处理中"
				}
                this.order_uuid = this.detailList.uuid;
				this.pay_type = this.detailList.pay_type;
				// 补充信息
				if(this.detailList.order_supplement_img && this.detailList.order_supplement_img.length){
				    this.detailList.order_supplement_img.forEach((item,index)=>{
						if(!item.includes("http") && !item.includes("https")){
							this.detailList.order_supplement_img[index] = this.imgUrl + this.detailList.order_supplement_img[index];
						}
				    })
				}
				
				// 判断是否超过5天
				let createTime = new Date(this.detailList.pay_time).getTime();					//支付时间
				let noweTime = new Date().getTime();								//当前时间
				let fiveDayTime = 5*24*60*60*1000;
				if(noweTime - createTime >fiveDayTime){//超过5天
					this.$set(this.detailList,"isOverFive", true);
				}else{
					this.$set(this.detailList,"isOverFive", false);
				}
				
				//过滤不展示按钮的状态
				if(this.detailList.order_status!="2" && this.detailList.order_status!="6" && this.detailList.order_status!="7"){
					this.isShowStatus = true
				}
			},
			
			// 操作订单
			async operateOrder(type,reason_for_rejection){
				let parmas ={type:type,reason_for_rejection:reason_for_rejection}
				const { data, status } = await operateOrder(this.order_uuid,parmas);
				if (status !== 200) return 
                if(type==3){//操作驳回
                    this.isReject = false
                    this.ToastText = "订单申请驳回成功 请等待管理员处理";
                    this.isToast = true;
                    this.getOrderDetail();
                }
                if(type==2){//确认完成订单
                    this.isSubmit = false
                    this.$router.push({path:'./operate-success',query:{order_uuid:this.order_uuid,flag:"success",role:"user"}})
                }
                
                if(type==1){//确认取消订单
                    this.isCancel = false
                    this.ToastText = "订单已成功取消";
                    this.isToast = true;
                    this.getOrderDetail()
                }else if(type==5){//退款
					let backurl = location.href;
					this.$router.push({path:'./refund-detail',query:{order_uuid:this.order_uuid,backurl:backurl,refund:"user"}})
				}
			},
			
			//撤单
			rescind(){
				this.tipObj = {
					title:"您确定要撤单么？",
					content:'您的订单在五天处理期限内，现在撤单，根据<span id="agree" style="color: #4184F4;">《下单协议》</span>须扣除订单金额50%违约金哦，您确定么？',
					num:1
				}
				this.isShowTips = true;
			},
			
			//退款
			refund(){
				if(this.detailList.order_status == 3 || this.detailList.order_status == 11){//点击处理中显示的退款按钮,未解决中退款
					this.tipObj = {
						title:"确定要申请退款么？",
						content:'申请退款后，款项48小时内原路退回。',
						num:2
					}
					this.isShowTips = true;
				}else{
					let backurl = location.href;
					this.$router.push({path:'./refund-detail',query:{order_uuid:this.order_uuid,backurl:backurl,refund:"user"}})
				}
			},
			
			// 订单被驳回
			reject(){
				this.isReject = true;
			},
			
			// 取消订单
			cancel(){
				this.isCancel = true;
			},
			
			//跟进
			follow(){
				this.$router.push({path:'./order-speed',query:{order_uuid:this.order_uuid,follow:"user"}})
			},
            
            //完成订单
            submit(){
                this.isSubmit = true;
            },
			
			// 补充资料
			supply(){
				this.isSupplyFollow = true;
			},
			
			//确认撤单和退款,此时就是退款	
			submitFun(){
				this.operateOrder("5");
				this.isShowTips = false;
			},
			
			//确认驳回订单
			clickReject(selectFlag,otherReason){
				let reason_for_rejection="";
				if(selectFlag==0){
					reason_for_rejection = "未解决问题"
				}else if(selectFlag==1){
					if(!otherReason){
						window.toast("请输入驳回理由","txt");
						return
					}
					if(otherReason.length>100){
						window.toast("驳回理由不得超过100字","txt");
						return
					}
					reason_for_rejection = otherReason
				}
				this.operateOrder(3,reason_for_rejection)
			},
			
			//补充资料
			async submitSupplyAdd(content,img){
				let parmas ={order_uuid:this.order_uuid,order_supplement:content,order_supplement_img:JSON.parse(img)}
				const { data, status } = await addSupplement(parmas);
				if (status !== 200) return 
				this.isSupplyFollow = false;
				this.ToastText = "信息补充成功";
				this.isToast = true;
				setTimeout(()=>{
					this.getOrderDetail();
					this.isToast = false
				},1500)
			},
            
            // 立即支付
            payMent(){
                this.isPayModal = true;
            },
			
			//立即评价
			comment(){
			    this.$router.push({path:'./assess',
			        query:{
			            order_uuid:this.order_uuid,
			            server_icon:this.detailList.server_info.server_icon,
			            server_name:this.detailList.server_info.server_name,
                        url:location.href
			        }
			    });
			},
			
            //确认支付
            async payClick(payStyle){
				this.payStyle = payStyle;
				if(!this.clickPay) {
					window.toast("请勿重复点击","txt");
					return;
				}
				this.clickPay = false;
                setTimeout(()=>{
                    this.clickPay = true;
                },3000)
                
				let obj ={type:this.payStyle,order_uuid:this.order_uuid};
              let web_obj = {type:this.payStyle,order_uuid:this.order_uuid};
				if(this.isMobile==1){
					obj.order_tag = 1
				}else if(this.isMobile==2){
					obj.order_tag = 2
				}else if(this.isMobile==3){
					obj.order_tag = 3
				}

              //判断一下是不是在小程序中
              wx.miniProgram.getEnv(function (res) {
                if (res.miniprogram) {
                  // 小程序环境下逻辑
                  console.log("小程序环境,需要调用小程序支付");
                  //obj.order_tag = 3;
                  web_obj.order_tag = 4;
                  obj.wx_type   = 'minApp' //小程序
                }
              });
				
				const { data, status } = await getOrderPay(obj);
				this.isPayModal = false;
				if(status==200){
					if(this.payStyle=="2"){//钱包支付
						this.$router.push({path:"./pay-success",query: {order_uuid:data.order_uuid,totalPrice:this.detailList.order_total_price}});
					}
					else{//微信支付
						if(web_obj.order_tag == 2){//扫码支付
							this.isPayModal = false;
							this.order_tag = "2";
							this.qrcodeUrl = data.code_url;							
						} else if(web_obj.order_tag == 1) {
							this.order_tag = "1";
							sessionStorage.setItem("havePay","havePay");
							sessionStorage.setItem("payId",data.order_uuid);
							var UserAgent = navigator.userAgent.toLowerCase();
							if(/safari/.test(UserAgent) && !/chrome/.test(UserAgent)){
								var backUrl = "https://server-order.yongxintao.com/#/pay-success?order_uuid="+data.order_uuid+"&totalPrice="+this.detailList.order_total_price
								sessionStorage.setItem("backUrl",backUrl);
								location.href = data.mweb_url;
							}else{
								location.href = data.mweb_url;
							}
						}else if(web_obj.order_tag == 3){//微信公众号支付
							let timeStamp = String(data.timeStamp);
							this.order_tag = "3"
							this.pay("wxf3c9d00e530fedd8",timeStamp,data.nonceStr,data.package,data.signType,data.paySign);
						}else if (web_obj.order_tag == 4){
              //小程序支付
              //this.AWechatJsPay();
              data.timeStamp = String(data.timeStamp);

              const payParamsStr = encodeURIComponent(JSON.stringify(data));
              const url=`../wxpay/wxpay?payParamsStr=${payParamsStr}`;
              wx.miniProgram.navigateTo({url:url});
              console.log('跳到小程序支付页面中去')
            }
					}
					this.order_uuid = data.order_uuid;
					this.getPayStatus() 
				}else{
					if(data.error.message == "余额不足" && this.payStyle=="2"){
						this.noEnough = true;
					}
				} 
            },
            
            // 调微信支付
            pay(appId,timeStamp,nonceStr,packages,signType,paySign){  
            	let self = this;
                if (typeof WeixinJSBridge == "undefined"){  
                   if( document.addEventListener ){  
                       document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);  
                   }else if (document.attachEvent){  
                       document.attachEvent('WeixinJSBridgeReady', onBridgeReady);   
                       document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);  
                   }  
                }else{  
                   self.onBridgeReady(appId,timeStamp,nonceStr,packages,signType,paySign);  
                }   
            },  
            
            //唤醒微信支付
            onBridgeReady(appId,timeStamp,nonceStr,packages,signType,paySign){
                let self = this;
            	WeixinJSBridge.invoke(
            		'getBrandWCPayRequest',
            		{
            			"appId":"wxf3c9d00e530fedd8",     //公众号名称，由商户传入     
            			"timeStamp":timeStamp,         //时间戳，自1970年以来的秒数     
            			"nonceStr":nonceStr, //随机串     
            			"package":packages,     
            			"signType":signType,         //微信签名方式：     
            			"paySign":paySign //微信签名 
            		},
            		
            		function(res){
            			if(res.err_msg == "get_brand_wcpay_request:ok"){// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
							self.$router.push({path:"./pay-success",query: {order_uuid:self.order_uuid,totalPrice:this.detailList.order_total_price}});
            			}else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
                            window.toast("支付失败","txt");
            			}else if (res.err_msg === 'get_brand_wcpay_request:fail') {
                            window.toast("支付失败","txt");
            			}
            		}
            	)
            },
			
			// 轮询支付状态
			async getPayStatus(){
				clearTimeout(this.timer);
				const { data, status } = await getOrderDetail(this.order_uuid);
				if( status == 200 && data.is_pay == 2){
					clearTimeout(this.timer);
					this.qrcodeUrl = false;
                    this.isPayModal = false;
					this.$router.push({path:"./pay-success",query: {order_uuid:this.order_uuid,totalPrice:this.detailList.order_total_price}});
				}else{
					clearTimeout(this.timer);
					this.timer = setTimeout(()=>{
						this.getPayStatus()
					},2000)
				}
			},

            navigateTo(path){
                this.$router.push(path)
            },
            
            // 关闭弹框
            onCloseModalClick(){
				this.isShowTips = false,
				this.isReject = false;
                this.isSubmit = false;
                this.isCancel = false;
                this.isPayModal = false;
                this.noEnough = false;      //取消充值
				this.qrcodeUrl = false;
				this.isAgreeMent = false;
				this.isSupplyFollow = false;
				clearTimeout(this.timer);
            },
			
			//关闭协议
			onCloseModalAgree(){
				this.isAgreeMent = false;	//关闭协议弹框
			},
            
            // 去充值
            goToCharge(){
            	this.noEnough = false;
            	this.$router.push({path:"./recharge",query: {url:location.href}})
            },

			backHeight(){
			    setTimeout(() => {
			        const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
			        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
			    }, 100);
			},
			
			handleImgsClick(item,index) {
				this.initialIndex = index
				const params = {
					$props: {
						imgs: item,
						initialIndex: 'initialIndex', // 响应式数据的key名
						loop: false
					},
					$events: {
						change: (i) => {
							// 必须更新 initialIndex
							this.initialIndex = i
						}
					}
				}
				this.$createImagePreview({ ...params }).show()
			}
        }
    }
</script>

<style lang='less' scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
    section{overflow: hidden;font-family:PingFangSC-Regular;font-weight:400;background:#F5F5F5;padding:10px 10px 57px 10px;}
	.no-p{padding-bottom: 10px}
	.banner{width: 375px;height: 100px;padding:27px 0 0 40px;font-size: 18px; font-family: PingFangSC-Medium;font-weight: 500;color: rgba(255,255,255,1);background: url(../../assets/images/home/pic_order_banner.png) no-repeat center center;background-size: cover}
    .service-left{color:rgba(51,51,51,1);text-align: justify;display: inline-block;vertical-align: top;.f-s(15);font-family:PingFangSC-Medium;font-weight:500;}
	/* .order-content{margin:10px 10px 0 10px;} */
	.order-detail{margin-bottom: 10px;background: #fff}
	.order-wrap{font-size: 0;height: 1.38666667rem;margin:0 10px;line-height: 1.38666667rem;display: -webkit-box;display: -ms-flexbox;display: -webkit-flex;display: flex;border-bottom: 0.026667rem solid #E5E5E5;align-items: center;font-weight: 500}
	.have-between{justify-content: space-between;}
	.pt-img{height: 20px;margin-right: 8px;display: inline-block;vertical-align:middle}
	.order-left{color:rgba(51,51,51,1);font-size:13px;}
	.add-font{font-size: 14px;font-weight: 600;}
    .link-wrap{font-size: 0;height: 1.38666667rem;margin: 0 10px;line-height: 1.38666667rem;border-bottom: 0.026667rem solid #EEEEEE;}
	.link{display: inline-block;vertical-align: middle;color:rgba(20,20,20,1);font-size: 0.4rem;}
	.show-link{width: 335px;padding: 10px;margin: 0 auto;color:rgba(74,74,74,1);font-size: 14px;box-sizing: content-box}
    .customer-info{padding: 10px 10px 2px 10px;display: -webkit-box;display: -ms-flexbox;display: flex;justify-content: space-between;align-items: center;}
    .info-style{color:rgba(74,74,74,1);font-size: 14px}
    .p-b{padding-bottom:8px}
    .f-s{color: #4a4a4a;font-size: 0.373333rem;}
    .un-connection{display: inline-block;color:rgba(65,132,244,1);font-size: 13;padding:5px 17px;background:rgba(239,247,255,1);border-radius:4px;margin: 11px 0 9px 10px}
    .img-list{display: -webkit-box;display: -ms-flexbox;display: flex;flex-wrap: wrap;padding:0 10px}
    .img-size{width: 95px;height:95px;margin-right: 16px;margin-bottom: 7.5px}
	.img-list .img-size:nth-child(3n){margin-right: 0}
    .agree-img{width: 22px;height: 22px;margin-right: 8px;display: inline-block;vertical-align:middle}
    .agree{background: url(../../assets/images/home/pic_right2_pitchon.png) center center no-repeat;background-size: cover}
    .un-agree{background: url(../../assets/images/home/pic_right2_pitchoff.png) center center no-repeat;background-size: cover}
    .agree-text{padding: 10px 22px 10px 15px}
    .agree-text p{font-size:14px;color:rgba(20,20,20,1);line-height:20px;margin-bottom: 10px}
    .operat{position: fixed;bottom: 0;left: 0;width: 375px;height: 50px;background: #fff}
	.operat span{display: inline-block;width: 65px;height: 30px;margin-top: 10px;border-radius:2px;border: 1px solid rgba(153,153,153,1);text-align: center;line-height: 30px;color:rgba(153,153,153,1);font-size: 13px;}
	.reject{margin-left: 120px}
	.notes{margin-left: 20px}
	.operat .complete{margin-left: 26.5px;background:rgba(65,132,244,1);color:rgba(255,255,255,1);border: none}
	.only-one{float: right;margin-right: 10px;height: 100%;}
    /* 弹框 */
    .modal{width: 320px;/* height: 327px; */background: #fff;margin: 0 auto;padding-bottom: 20px;}
    .title{padding: 12px 21px;/* background: url(../../assets/images/home/pic_right2_pitchon.png) no-repeat 93% center;background-size: 12px; */font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);text-align: center;border-bottom: 1px solid #E9E9E9}
    .list-wrap{padding: 18px 21px 25px 21px;}
    .list-wrap li{margin-bottom: 10px}
    .select-mark{display: inline-block;width:17px;height:17px;border-radius: 50%;margin-right: 7px;vertical-align: top;margin-top: 4px}
    .on{background: url(../../assets/images/home/pic_right2_pitchon.png) no-repeat center center;background-size:cover;}
	.modal-text{display: inline-block;width: 243px;font-size:15px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(20,20,20,1);vertical-align: top;}
    .modal-submit{width:278px;height:40px;margin: 0 auto;line-height:40px;border-radius:2px;font-size:18px;font-family:PingFangSC-Regular;font-weight:400;background:rgba(65,132,244,1);text-align: center;color:rgba(255,255,255,1);}

    
    /* 取消订单弹框 */
    .pay-wrap{width: 207.5px;height: 200px;background: #fff;padding-top: 43px}
    .logo{width: 70px;height: 70px;margin: 0 auto;background: url(../../assets/images/order-manage/ic_order_off.png) no-repeat center center;background-size: cover;}
    .successText{margin-top: 18px;font-size:14px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(20,20,20,1);text-align: center}

	/* 驳回理由 */
	.textarea{width: 278px;height: 105px;padding: 10px;background:rgba(245,245,245,1);border-radius:2px;border:1px solid rgba(207,207,207,1);resize: none;outline: none}
	.done{background: url(../../assets/images/home/pic_right2_pitchon.png) no-repeat center center;background-size:cover;}
	.undone{background: url(../../assets/images/home/pic_right2_pitchoff.png) center center no-repeat;background-size: cover}

    /* 充值成功 */
    .modal-balance{.w(280);.f-s(18);background:rgba(255,255,255,1);border-radius:4px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(0,0,0,1);}
    .body {width: 130px;margin:0 auto;.p-t(38);.m-b(32);text-align: center;font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1)}
    .footer {display: flex;justify-content: center;align-items: center;text-align: center;border-top: 1px solid #DDDDDD;}
    .cancelBtn, .confirmBtn {.w(140);.h(50);.l-h(50);font-size:18px;}
    .cancelBtn {border-right: 1px solid #DDDDDD;color:rgba(153,153,153,1)}
    .confirmBtn {font-family:PingFangSC-Medium;font-weight:500;color:rgba(65,132,244,1)}
	.supply-content{padding: 10px 15px 15px 10px;font-size:14px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(102,102,102,1);}
</style>
